import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

const IdleWarningDialog = ({ isVisible, onStayActive, onLogout }) => {
  return (
    <Dialog
      open={isVisible}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown
      disableBackdropClick
    >
      <DialogTitle>Session Timeout Warning</DialogTitle>

      <DialogContent>
        <Typography>
          You have been inactive for a while. Would you like to stay logged in?
        </Typography>
      </DialogContent>

      <DialogActions sx={{ p: 2.5, gap: 1 }}>
        <Button
          variant="outlined"
          onClick={onLogout}
          sx={{
            color: "grey.700",
            borderColor: "grey.400",
            "&:hover": {
              borderColor: "grey.600",
              backgroundColor: "grey.50",
            },
          }}
        >
          Logout
        </Button>
        <Button
          variant="contained"
          onClick={onStayActive}
          sx={{
            backgroundColor: "#00AB4E",
            "&:hover": {
              backgroundColor: "#008C40",
            },
          }}
        >
          Stay Logged In
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default IdleWarningDialog;